import { SxProps } from "@mui/system";
import type { ThemeV2 } from "../../../util/types";

export const landscapeImageStyle = (
  theme: ThemeV2,
  maxHeight: number | string,
): SxProps => ({
  maxHeight: typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight,
  borderRadius: `${theme.tokens.shape.radius.lg}px`,
  maxWidth: "100%",
  width: "auto",
  height: "auto",
  margin: "0 auto",
});

const xsMinwidthValue = (orientation: string | undefined) => {
  if (orientation === "portrait-land") {
    return "90%";
  } else {
    return "100%";
  }
};
export const questionContentContainer = (
  orientation: string | undefined,
  theme: ThemeV2,
): SxProps => ({
  minHeight: 0,

  minWidth: { xs: xsMinwidthValue(orientation), md: "40%" },
  maxWidth: { xs: xsMinwidthValue(orientation), md: "100%" },
  height: "100%",
  display: "flex",
  justifyContent: "space-around",
  padding: `${theme.tokens.spacing["5"]}px ${theme.tokens.spacing["4"]}px`,
  backgroundColor: theme.tokens.color.surface.card,
  border: `1px solid ${theme.tokens.color.border.default}`,
  borderRadius: `${theme.tokens.shape.radius.md}px`,
  flexDirection: "column",
  gap: `${theme.tokens.spacing["2"]}px`,
  boxShadow: theme.tokens.elevation["3"],
  "&::-webkit-scrollbar": {
    width: "8px",
  },
});
